import { Injectable, EventEmitter } from '@angular/core';
import gql from 'graphql-tag';
import { Apollo } from 'apollo-angular';

@Injectable()
export class UtlPerFinService {
  constructor(private apollo: Apollo) {}

  horizontalScrollTableColumns = new EventEmitter();

  getTable8Data(searchOpts) {
    /* parameters:
    startYear
    tableId=msas
    region
    */
    const query = gql`
      query getTable8($startYear: String, $region: String, $tableId: String) {
        getTable8Data(startYear: $startYear, region: $region, tableId: $tableId){
          tableTitle
          tableSubtitle
          tableDetails
          download{
            pdf
            excel
          }
          data{
            section{
              label
              row{
                cell{
                  label
                  value
                  heading
                }
              }
              subsection{
                label
                row{
                  cell{
                    label
                    value
                    heading
                  } 
                }
                subsection{
                  label
                  row{
                    cell{
                      label
                      value
                      heading
                    }              
                  }
                }
              }
            }
          }
        }
      }
    `;
    return this.apollo.watchQuery<any>({
      query: query,
      variables: searchOpts
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/t8-utl-per-fin/utl-per-fin.service.ts